/**
 * Flight School MCQ option image assets (PWA parity).
 *
 * iOS source of truth: client-native/src/features/flight-school/lib/activityAssets.ts
 * Maps the four image-icon keys to bundled PNGs (ported from
 * client-native/assets/flight-school/*-option.png) so MCQ options like the
 * "Her hat / dress / shoes / phone" question render the real image, not text.
 */
import type { ActivityData } from "./activityTypes";
import hatOption from "../assets/hat-option.png";
import phoneOption from "../assets/phone-option.png";
import shoesOption from "../assets/shoes-option.png";
import dressOption from "../assets/dress-option.png";
import frisbeeOption from "../assets/frisbee-option.png";

export type MCQOptionImageName = "hat" | "phone" | "shoes" | "dress" | "frisbee";

const OPTION_IMAGE_SOURCES: Record<MCQOptionImageName, string> = {
  hat: hatOption,
  phone: phoneOption,
  shoes: shoesOption,
  dress: dressOption,
  frisbee: frisbeeOption,
};

export function getMCQOptionImageSource(image: MCQOptionImageName): string {
  return OPTION_IMAGE_SOURCES[image];
}

/**
 * Warm the next activity's MCQ option images so they render instantly on
 * advance. PWA equivalent of iOS preloadFlightSchoolActivityAssets
 * (activityAssets.ts) — `Image.prefetch` becomes a detached `new Image().src`.
 */
export function preloadFlightSchoolActivityAssets(
  activity: ActivityData | undefined,
): void {
  if (activity?.type !== "mcq") return;
  for (const option of activity.options) {
    const image = option.icon?.image;
    if (image) {
      const img = new Image();
      img.src = getMCQOptionImageSource(image);
    }
  }
}
